import { ThemeOptions } from '@mui/material/styles';

export const defaultPalette = {
    secondary: {
        main: '#b923b5',
        light: '#ce65cb',
        dark: '#81187e',
        contrastText: '#F2F2F2',
    },
    backgroundMainLayout: {
        main: '#E8E8FF',
        light: '#F7F7FF',
    },
    sidebarHeader: {
        main: '#b923b5',
        light: '#f50057',
        dark: '#f50057',
        contrastText: '#F2F2F2',
    },
    appHeader: {
        main: '#b923b5',
        contrastText: '#fff',
    },
    pageNavigationBar: {
        main: '#0b6fba',
        light: '#207abd',
        dark: '#0A3B62',
        contrastText: '#7fc91e',
    },
    conversationTimelinePaper: {
        main: '#0b6fba',
        light: '#76c016',
    },
    addButton: {
        main: '#3f51b5',
        light: '#fafbff',
    },
    menuListHover: {
        main: '#E8E8FF',
        light: '#F7F7FF',
    },
    btnDefault: {
        main: '#000000de',
        light: '#F5F5F5',
    },
    noteStatus: {
        main: '#fff3a5',
        light: '#c0e5ff',
    },
    tabPills: {
        main: '#0b6fba',
        light: '#F5F5F5',
    },
} as ThemeOptions['palette'];
